var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content ipNumbers" }, [
    _c("div", { staticClass: "card" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "card-body" },
        [
          _c("div", [
            _c("h6", [_vm._v("Новый номер")]),
            _vm._v(" "),
            _c(
              "form",
              {
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return _vm.updateRecords("new")
                  },
                },
              },
              [
                _c("div", { staticClass: "flex new_record_block" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "" } }, [
                      _vm._v("Телефон для отображения"),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.newRecord.display_phone,
                          expression: "newRecord.display_phone",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text", required: "" },
                      domProps: { value: _vm.newRecord.display_phone },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.newRecord,
                            "display_phone",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "" } }, [_vm._v("Формат")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.newRecord.phone,
                          expression: "newRecord.phone",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: { required: "", type: "text" },
                      domProps: { value: _vm.newRecord.phone },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.newRecord, "phone", $event.target.value)
                        },
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "" } }, [_vm._v("Описание")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.newRecord.description,
                          expression: "newRecord.description",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: { required: "", type: "text" },
                      domProps: { value: _vm.newRecord.description },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.newRecord,
                            "description",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "" } }, [_vm._v("Сайт")]),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.newRecord.site_id,
                            expression: "newRecord.site_id",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { required: "" },
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.newRecord,
                              "site_id",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                        },
                      },
                      [
                        _c("option", { attrs: { value: "0" } }, [
                          _vm._v("Все проекты"),
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.$AllProjects, function (project) {
                          return project.id
                            ? _c(
                                "option",
                                { domProps: { value: project.id } },
                                [
                                  _vm._v(
                                    _vm._s(project.name) + "\n                "
                                  ),
                                ]
                              )
                            : _vm._e()
                        }),
                      ],
                      2
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "" } }, [_vm._v("Город")]),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.newRecord.city_id,
                            expression: "newRecord.city_id",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { required: "" },
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.newRecord,
                              "city_id",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                        },
                      },
                      _vm._l(_vm.$AllCities, function (city) {
                        return city.id
                          ? _c("option", { domProps: { value: city.id } }, [
                              _vm._v(
                                _vm._s(city.short_name) +
                                  " -\n                  " +
                                  _vm._s(city.name) +
                                  "\n                "
                              ),
                            ])
                          : _vm._e()
                      }),
                      0
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "" } }, [_vm._v("MANGO ID")]),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.newRecord.service_id,
                            expression: "newRecord.service_id",
                          },
                        ],
                        staticClass: "form-control",
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.newRecord,
                              "service_id",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                        },
                      },
                      _vm._l(_vm.mangoAccs, function (title, accId) {
                        return _c("option", { domProps: { value: accId } }, [
                          _vm._v(_vm._s(title)),
                        ])
                      }),
                      0
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "text-right" },
                  [
                    _c(
                      "vue-ladda",
                      {
                        attrs: {
                          "button-class": "btn btn-sm btn-success",
                          "data-style": "zoom-in",
                          type: "submit",
                          loading: _vm.saveLoading,
                        },
                      },
                      [_vm._v("Сохранить новый номер\n            ")]
                    ),
                  ],
                  1
                ),
              ]
            ),
            _vm._v(" "),
            _c("hr"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "flex justify-content-between" }, [
            _c("div", [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.filter.site_id,
                      expression: "filter.site_id",
                    },
                  ],
                  staticClass: "form-control",
                  on: {
                    change: function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.filter,
                        "site_id",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    },
                  },
                },
                [
                  _c("option", { attrs: { value: "0" } }, [
                    _vm._v("Все проекты"),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.$AllProjects, function (project) {
                    return _c("option", { domProps: { value: project.id } }, [
                      _vm._v(_vm._s(project.title)),
                    ])
                  }),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              [
                _c(
                  "vue-ladda",
                  {
                    attrs: {
                      "button-class": "btn btn-outline-info",
                      "data-style": "zoom-in",
                      type: "button",
                      loading: _vm.saveLoading,
                    },
                    on: { click: _vm.getRecords },
                  },
                  [_vm._v("Показать\n          ")]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("pulse-loader", {
            staticClass: "text-center",
            attrs: { loading: _vm.loading, color: _vm.loadingColor },
          }),
          _vm._v(" "),
          _vm.records
            ? _c("div", [
                _c(
                  "table",
                  { staticClass: "table table-sm table-hover mt-3" },
                  [
                    _vm._m(1),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.records, function (record, index) {
                        return _c(
                          "tr",
                          { class: { modified: record.modified } },
                          [
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  index +
                                    1 +
                                    (_vm.paginator.current_page - 1) *
                                      _vm.paginator.per_page
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: record.display_phone,
                                    expression: "record.display_phone",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: { type: "text" },
                                domProps: { value: record.display_phone },
                                on: {
                                  change: () => (record.modified = true),
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      record,
                                      "display_phone",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: record.phone,
                                    expression: "record.phone",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: { type: "text" },
                                domProps: { value: record.phone },
                                on: {
                                  change: () => (record.modified = true),
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      record,
                                      "phone",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: record.description,
                                    expression: "record.description",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: { type: "text" },
                                domProps: { value: record.description },
                                on: {
                                  change: () => (record.modified = true),
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      record,
                                      "description",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: record.site_id,
                                      expression: "record.site_id",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  on: {
                                    change: [
                                      function ($event) {
                                        var $$selectedVal =
                                          Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function (o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function (o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                        _vm.$set(
                                          record,
                                          "site_id",
                                          $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        )
                                      },
                                      () => (record.modified = true),
                                    ],
                                  },
                                },
                                [
                                  _c("option", { attrs: { value: "0" } }, [
                                    _vm._v("Все проекты"),
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(_vm.$AllProjects, function (project) {
                                    return project.id
                                      ? _c(
                                          "option",
                                          {
                                            attrs: {
                                              disabled: !project.is_active,
                                            },
                                            domProps: { value: project.id },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(project.name) +
                                                "\n                "
                                            ),
                                          ]
                                        )
                                      : _vm._e()
                                  }),
                                ],
                                2
                              ),
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: record.city_id,
                                      expression: "record.city_id",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  on: {
                                    change: [
                                      function ($event) {
                                        var $$selectedVal =
                                          Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function (o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function (o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                        _vm.$set(
                                          record,
                                          "city_id",
                                          $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        )
                                      },
                                      () => (record.modified = true),
                                    ],
                                  },
                                },
                                _vm._l(_vm.$AllCities, function (city) {
                                  return city.id
                                    ? _c(
                                        "option",
                                        { domProps: { value: city.id } },
                                        [
                                          _vm._v(
                                            _vm._s(city.short_name) +
                                              " -\n                  " +
                                              _vm._s(city.name) +
                                              "\n                "
                                          ),
                                        ]
                                      )
                                    : _vm._e()
                                }),
                                0
                              ),
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: record.service_id,
                                      expression: "record.service_id",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  on: {
                                    change: [
                                      function ($event) {
                                        var $$selectedVal =
                                          Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function (o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function (o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                        _vm.$set(
                                          record,
                                          "service_id",
                                          $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        )
                                      },
                                      () => (record.modified = true),
                                    ],
                                  },
                                },
                                _vm._l(_vm.mangoAccs, function (title, accId) {
                                  return _c(
                                    "option",
                                    { domProps: { value: accId } },
                                    [_vm._v(_vm._s(title))]
                                  )
                                }),
                                0
                              ),
                            ]),
                          ]
                        )
                      }),
                      0
                    ),
                  ]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex justify-content-between" },
            [
              false && _vm.paginator
                ? _c("paginate", {
                    ref: "Pagination",
                    attrs: {
                      "page-count": _vm.paginator.last_page,
                      "page-range": 11,
                      "margin-pages": 2,
                      "click-handler": _vm.getRecords,
                      "prev-text": "&laquo",
                      "next-text": "&raquo",
                      "container-class": "pagination",
                      "prev-class": "page-item",
                      "prev-link-class": "page-link",
                      "page-class": "page-item",
                      "page-link-class": "page-link",
                      "next-class": "page-item",
                      "next-link-class": "page-link",
                      "active-class": "active green_btn",
                    },
                    model: {
                      value: _vm.currentPage,
                      callback: function ($$v) {
                        _vm.currentPage = $$v
                      },
                      expression: "currentPage",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c(
                    "vue-ladda",
                    {
                      attrs: {
                        "button-class": "btn btn-sm btn-success",
                        "data-style": "zoom-in",
                        loading: _vm.saveLoading,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.updateRecords()
                        },
                      },
                    },
                    [_vm._v("Сохранить\n          ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", [_vm._v("IP телефоны")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Телефон для отображения")]),
        _vm._v(" "),
        _c("th", [_vm._v("Формат")]),
        _vm._v(" "),
        _c("th", [_vm._v("Описание")]),
        _vm._v(" "),
        _c("th", [_vm._v("Сайт")]),
        _vm._v(" "),
        _c("th", [_vm._v("Город")]),
        _vm._v(" "),
        _c("th", [_vm._v("Mango Acc")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }